/**
 * @module チェックリスト共通コンポーネント
 */
import NormaleButton from '../../components/button/Normal.vue';

export default {
  components: {
    NormaleButton,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    items: {
      type: Array,
      default: [],
      required: false,
    },
    onAllClick: {
      type: Function,
      default: () => {},
    },
    onClearClick: {
      type: Function,
      default: () => {},
    },
    checkValid: {
      type: Function,
      default: () => {},
    },
    checkboxWidth: {
      type: Number,
      default: 50,
      required: false,
    },
    firstTimeName: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      panelExpand: [],
    };
  },
  mounted() {
    this.panelExpand = Boolean(localStorage.getItem(this.firstTimeName)) === true ? [] : [0];
  },
};
